import { TEST_ID_PLAYER_KANBAN } from "e2e/testId";
import React, { memo } from "react";

import { Pressable } from "@/components/atoms/Pressable";
import { Text } from "@/components/atoms/Text";

/**
 * Props for BoardTabView component
 */
interface BoardTabViewProps {
  /** Display name of the board */
  readonly name: string;
  /** Whether this tab is currently active */
  readonly isActive: boolean;
  /** Callback when tab is pressed */
  readonly onPress: () => void;
}

/**
 * Individual board tab presentation component
 * Displays a clickable tab with active state styling
 * @param root0 - Component props
 * @param root0.name - Display name of the board
 * @param root0.isActive - Whether this tab is currently active
 * @param root0.onPress - Callback when tab is pressed
 */
const BoardTabView = ({ name, isActive, onPress }: BoardTabViewProps) => (
  <Pressable
    testID={TEST_ID_PLAYER_KANBAN.BOARD_TAB}
    onPress={onPress}
    className={`h-10 min-w-32 items-center justify-center rounded-t-sm px-4 py-2 ${
      isActive
        ? "border-b-2 border-b-accent-primary bg-surface-base"
        : "bg-transparent"
    }`}
  >
    <Text
      variant="body-strong"
      className={`${isActive ? "text-content-primary" : "text-content-muted"}`}
      isTruncated
    >
      {name}
    </Text>
  </Pressable>
);

BoardTabView.displayName = "BoardTabView";

export default memo(BoardTabView);
